import { render, staticRenderFns } from "./salesBigCustomerSetting.vue?vue&type=template&id=3ab3025f&scoped=true"
import script from "./salesBigCustomerSetting.vue?vue&type=script&lang=js"
export * from "./salesBigCustomerSetting.vue?vue&type=script&lang=js"
import style0 from "./salesBigCustomerSetting.vue?vue&type=style&index=0&id=3ab3025f&prod&scoped=true&lang=css"
import style1 from "./salesBigCustomerSetting.vue?vue&type=style&index=1&id=3ab3025f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ab3025f",
  null
  
)

export default component.exports